export const feedbackConstants = {
  GET_FEEDBACK_REQUEST: "FEEDBACK_GET_REQUEST",
  GET_FEEDBACK_SUCCESS: "FEEDBACK_GET_SUCCESS",
  GET_FEEDBACK_FAILURE: "FEEDBACK_GET_FAILURE",

  POST_FEEDBACK_REQUEST: "FEEDBACK_POST_REQUEST",
  POST_FEEDBACK_SUCCESS: "FEEDBACK_POST_SUCCESS",
  POST_FEEDBACK_FAILURE: "FEEDBACK_POST_FAILURE",
};